import React from "react";
import "./css/PartnershipOpportunities.css";

export const PartnershipOpportunities: React.FC = () => {
    return (
        <div className="partnership-container">
            <div className="partnership-image-wrapper">
                <img
                    src="./images/webp/partnership-in-business.webp"
                    alt="Partnership in business"
                    className="partnership-image"
                />
            </div>

            <section className="partnership-section">
                <h2>Embed Skitterbook as a Component</h2>
                <p>
                    Organisations and developers interested in integrating Skitterbook directly into
                    their own applications can partner with FAR Authoring to embed Skitterbook as a
                    reusable component. This option is ideal for platforms that wish to offer
                    Skitterbook’s creative tooling natively within their own user experience.
                </p>
            </section>

            <section className="partnership-section">
                <h2>Distribute the Printed Product</h2>
                <p>
                    Businesses wishing to act as distributors of the physical printed Skitterbook
                    product can partner with FAR Authoring to supply, promote, and deliver the
                    finished books to customers. This model suits retailers, print‑on‑demand
                    services, and creative‑industry partners.
                </p>
            </section>

            <section className="partnership-contact">
                <p>
                    To explore either partnership model, please contact FAR Authoring at:
                </p>

                <p className="partnership-email">
                    <a
                        href="mailto:farauthoring@gmail.com?subject=Partnership%20Opportunity"
                    >
                        farauthoring@gmail.com
                    </a>
                </p>

                <p className="partnership-note">
                    When reaching out, please include the subject line <strong>Partnership Opportunity</strong>.
                </p>
            </section>
        </div>
    );
};

export default PartnershipOpportunities;
